import React from "react";
import { useWinStore } from "./windowStore";
import { WindowFrame } from "./WindowFrame";
import { Taskbar } from "./Taskbar";
import { DesktopPortal } from "./DesktopPortal";

export const WindowManager: React.FC = () => {
  const windows = useWinStore((s) => s.windows);

  return (
    <DesktopPortal>
      <div
        id="wm-layer"
        style={{
          position: "fixed",
          inset: 0,
          // Por encima de `.app-header` (1025), del menú lateral (1026), del
          // FloatingPanel (1027+) y de `.invoice-expanded-overlay` (1030), y
          // por debajo de los modales de Bootstrap (1050/1055).
          zIndex: 1040,
          pointerEvents: "none"
        }}
      >
        {windows.map((w) => (
          <WindowFrame key={w.id} win={w} />
        ))}
        <Taskbar />
      </div>
    </DesktopPortal>
  );
};
